import { render } from "./ProjectSectionRewards.vue?vue&type=template&id=e36cd6f8"
import script from "./ProjectSectionRewards.vue?vue&type=script&lang=js"
export * from "./ProjectSectionRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__